import { i18n } from 'platform-lib-app';

export default [
  {
    path: '/administration',
    name: 'administration',
    component: () => import('./index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_1398'),
    }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('./feedback/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_1276'),
      keepAlive: true,
    }
  },
];
